import React from 'react';

import { Outlet } from 'react-router-dom';

import { injectIntl } from 'react-intl';

import workflowReducer from './controllers/reducer';
import workflowSaga from './controllers/saga';

import { useInjectSaga } from 'utils/common/injectSaga';
import { useInjectReducer } from 'utils/common/injectedReducers';
import SuspenseLoading from 'common/components/loading/SuspendLoading';

const { lazy } = React;

const WorkflowDetail = lazy(() => import('./view/workflowDetail'));

const WorkflowGrid = lazy(() => import('./view/workflowGrid'));

export const workflowsRoutes = [
  {
    index: true,
    element: <WorkflowGrid />,
  },
];

export const workflowRoutes = [
  {
    index: true,
    element: <WorkflowDetail />,
  },
];

const Workflow = () => {
  useInjectReducer({ key: 'workflow', reducer: workflowReducer });
  useInjectSaga({ key: 'workflow', saga: workflowSaga });

  return (
    <SuspenseLoading>
      <Outlet />
    </SuspenseLoading>
  );
};

export default injectIntl(Workflow);
